import { render, staticRenderFns } from "./RedPaperPerson.vue?vue&type=template&id=6c505ccb&scoped=true"
import script from "./RedPaperPerson.vue?vue&type=script&lang=js"
export * from "./RedPaperPerson.vue?vue&type=script&lang=js"
import style0 from "./RedPaperPerson.vue?vue&type=style&index=0&id=6c505ccb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c505ccb",
  null
  
)

export default component.exports